import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { topics } from "@/mocks/topics";

export default function SiteFooter() {
  return (
    <footer className="mt-14 md:mt-20 bg-background-200 border-t border-background-300/70">
      <div className="h-1 w-full bg-primary-500" />
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                瓜
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料吃瓜网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 max-w-xs">
              专注娱乐八卦、明星动态与社会热点的资讯平台。快讯、观察与现场，一天更新三次。
            </p>
            <p className="mt-4 text-xs text-foreground-500 leading-relaxed">
              本站为演示站点，全部人物、事件与数据均为虚构示例，如有雷同纯属巧合。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <Link to="/" className="hover:text-primary-600 transition-colors">
                资讯栏目
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/search" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                  站内搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <Link to="/topic/topic-drama-2026" className="hover:text-primary-600 transition-colors">
                热门专题
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {topics.map((topic) => (
                <li key={topic.id}>
                  <Link
                    to={`/topic/${topic.id}`}
                    className="text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                  >
                    {topic.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <Link to="/about" className="hover:text-primary-600 transition-colors">
                联系与声明
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-foreground-500 mt-0.5" />
                <span>hi@heiliaogua.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-weibo-line text-foreground-500 mt-0.5" />
                <a
                  href="https://weibo.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="hover:text-primary-600 transition-colors"
                >
                  官方微博 @黑料吃瓜网
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-foreground-500 mt-0.5" />
                <span>内容更新：每日 08:00 / 14:00 / 21:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-5 border-t border-background-300/70 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-xs text-foreground-600">
          <span>© 2026 黑料吃瓜网 · 演示内容，仅供展示</span>
          <span className="flex items-center gap-4">
            <Link to="/about" className="hover:text-primary-600 transition-colors">
              使用须知
            </Link>
            <Link to="/about" className="hover:text-primary-600 transition-colors">
              版权声明
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}